import React from 'react'

import ProjectCollectionInStructureModel
    from "../../../../../../core/model2/project-collection/project-collection-in-structure-model"
import ProjectSession from "../../../../../../core/model2/project/project-session"
import MoreButton_Project from "../../../../../../core/gd-ui/more/project/more-button"
import PortfolioSettingsButton from "../../settings-button/portfolio-settings-button"
import {MoreButtonType} from "../../../../../../core/gd-ui/more/types"

// const debug = "PortfolioMoreButton"
const debug = false

export default function PortfolioMoreButton() {

    const projectCollection = gd.session.projectCollections.get(gd.projectCollectionViews.projectCollectionId)
    if (projectCollection?.isInStructure) {
        const pc = projectCollection as ProjectCollectionInStructureModel
        const project: ProjectSession = gd.session.projects.get(pc.customViewModel.parentProjectId!)!
        if (project.acl.hasStandardAccess) {
            return <MoreButton_Project buttonType   = {MoreButtonType.CONTROL_BUTTON_S28}
                                       hint         = "More"
                                       project      = {project}/>
        }
    } else {
        return <PortfolioSettingsButton projectCollectionId={gd.projectCollectionViews.projectCollectionId}/>
    }

    return null
}